import React from "react";
import deepBurgundyImg from "./../../../../Images/Blog/Top 10 hairColor/Deep Burgundy.png";
import HairServImg from "../HairBotox/HairServImg";

const DeepBurgundy = () => {
  return (
    <div className="blogHead-content">
      <HairServImg hairBotoxImg={deepBurgundyImg} />
      <h2>10. Deep Burgundy</h2>
      <p>
        Deep Burgundy is a rich and luxurious shade that is making waves in
        2024. This dark, wine-toned color is one of the <a href="https://scentlifestyle.com/top-10-trending-women-hair-colours-and-highlights-for-2024">Top 10 Trending Women
        Hair Colours & Highlights for 2024</a>, offering a bold and sophisticated
        look. Deep Burgundy is perfect for those who want to add depth and drama
        to their hair. This shade complements a variety of skin tones and works
        well with different hair lengths and textures. Whether you choose a full
        head of color or incorporate burgundy highlights, this shade is sure to
        make a statement.
      </p>
    </div>
  );
};

export default DeepBurgundy;
